Vue.component('projectObjectType', {
    data() {
        return {
            map: null,
            mapImage: null,
            mapContainer: null,
            listItems: [],
            objectPlots: jsonObjectPlots,
            plotList: [],
            mapAreas: null,
            accordionOpen: false,
            hoverVisible: false,
            plotIsOpen: false,
            statusFilters: false,
            activeStatusFilters: [],
            body: null,
            clickFromOutsideMap: false
        }
    },
    mounted() {
        this.body = document.getElementsByTagName("BODY")[0];
        this.map = document.querySelector('.js-objecttype-map');
        this.mapImage = document.querySelector('.js-objecttype-map-image');
        this.plotList = document.querySelectorAll('.js-plot-list-item');
        this.mapContainer = document.querySelector('.js-objectdetail-map');
        this.mapAreas = document.querySelectorAll('.objectdetail-map__area');
        this.statusFilters = document.querySelectorAll('.js-map-filter');

        imagesLoaded(this.map, () => {
            this.initializeMap();
        });

        window.addEventListener('resize', () => {
            this.initializeMap(false);
        });

        if(window.location.hash) {
            document.location.hash = window.location.hash
          }

    },
    filters: {
        //move to app.js
        formatCurrency(input) {
            return input.toLocaleString("nl-NL", {style: 'currency', currency: 'EUR', minimumFractionDigits: 0});
        }
    },
    methods: {
        initializeMap() {
            let overlayColorHex = '704214';
            let overlayOpacityValue = 1;
            var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

            if (typeof window.getComputedStyle(document.body).mixBlendMode === 'undefined' || isSafari) {
                overlayColorHex = '6c6557';
                overlayOpacityValue = 0.6;
                // EDE6D8

                // overlayColorHex = '989183';
                // overlayOpacityValue = 0.75;
            }

            if(this.map !== null) {
                imageMapResize(this.map);

                $(this.mapImage).maphilight({
                    fill: true,
                    fillColor: '0be900',
                    fillOpacity: 0.6,
                    stroke: true,
                    strokeColor: '002a5c',
                    strokeOpacity: 1,
                    strokeWidth: 1,
                    fade: true,
                    alwaysOn: false,
                    neverOn: false,
                    groupBy: false,
                    wrapClass: true,
                    shadow: true,
                    shadowX: 0,
                    shadowY: 0,
                    shadowRadius: 6,
                    shadowColor: '000000',
                    shadowOpacity: 0.8,
                    shadowPosition: 'outside',
                    shadowFrom: false,
                    overlay: true,
                    overlayColor: overlayColorHex,
                    overlayOpacity: overlayOpacityValue
                });
            }
        },
        togglePlotAccordion(e, plotNr) {
            const tooltip = e.currentTarget;
            const tooltipText = tooltip.querySelector(`.tooltiptext-${plotNr}`);

            //find tooltip for area
            if (tooltipText !== null) {
                this.getListItem(plotNr, true, e);
            } else {
                this.getListItem(plotNr, false, e);
            }
        },
        //qtip for click with parameters plot, if clicked on item outside map, closed
        togglePlotPopup(plot, triggerclick = false, event) {
            //make plot when it has coordinates and it does not excist yet
            if (plot.Coordinates !== "" && !plot.TooltipClick) {
                $(`#area-${plot.PlotNr}`).qtip({
                    content: {
                        text: $(`.tooltiptext-${plot.PlotNr}`),
                        button: $(`.tooltip-delete-${plot.PlotNr}`)
                    },
                    style: {
                        classes: `objectdetail-map-tooltip-${plot.PlotNr} objectdetail-map__qTip ${app.plotNotInInterestList(plot) && !app.plotIsSold(plot) ? `objectdetail-map__qTip--themecolor` : ``}`
                    },
                    position: {
                        container: $('.js-objectdetail-map'),
                        effect: function (api, pos, viewport) {
                            $(this).animate(pos, {
                                duration: 0,
                                easing: 'linear',
                                queue: false,
                                viewport: true,
                            });
                        },
                        my: 'bottom center',
                        at: 'top center',
                        adjust: {
                            screen: true,
                            x: 0,
                            y: 0
                        },
                    },
                    show: {
                        event: `click`
                    },
                    hide: {
                        //reset default hide event to nothing
                        event: ''
                    },
                    events: {
                        show: (e, api) => {
                            // Hide all qtips except current one
                            $('.qtip').not(`#${api._id}`).qtip('hide');
                            const plotNr = api.target[0].id.split('-')[1];
                            let listItem = this.getListItemByPlotNr(plotNr);

                            // Remove Map Hilights
                            this.removeMapHilights();
                            // Keep the map hilight of open plot
                            this.showMapHilight(plotNr);

                            //Show when not clicked on trigger click
                            //kijken of event een area is, ja? Dan triggerclick op false zetten
                            if(!this.clickFromOutsideMap) {
                                this.togglePlotAccordion(e, plotNr);
                            }
                            // if(!triggerclick && !listItem.dataset.accordionActive) {
                            //     this.togglePlotAccordion(e, plotNr);
                            // }

                            // console.log(event.target.id, api.target[0].id);
                            // if(event.target.id === api.target[0].id) {
                            //     console.log('in if');
                            //     this.togglePlotAccordion(e, plotNr);
                            // }
                        },
                        hide: (e, api) => {
                            const plotNr = api.target[0].id.split('-')[1];

                            // Only manually close accordion when close icon is clicked
                            if((api.mouse && window.innerWidth > 765) &&
                                (api.mouse.target.classList.contains(`tooltip-delete-${plotNr}`) ||
                                    api.mouse.target.parentElement.classList.contains(`tooltip-delete-${plotNr}`) ||
                                    api.mouse.target.parentElement.parentElement.classList.contains(`tooltip-delete-${plotNr}`)
                                )) {
                                this.togglePlotAccordion(e, plotNr);
                                this.removeMapHilights();
                            }
                        }
                    }
                })
                //remove data for other qtip
                .removeData('qtip');

                //set plot so it won't create one if it already exist
                Vue.set(plot, 'TooltipClick', true);
                this.testApi = $(`#area-${plot.PlotNr}`).qtip('api');
            }

            //if click is triggered outside map (accordion)
            if(triggerclick) {
                //open tooltip on click
                if($(`.objectdetail-map-tooltip-${plot.PlotNr}`).length) {
                      //Remove Map Hilights
                      this.removeMapHilights();

                      if($(`.objectdetail-map-tooltip-${plot.PlotNr}`).attr('aria-hidden') === 'true') {
                        // Keep the map hilight of open plot
                        this.showMapHilight(plot.PlotNr);
                      }

                    $('.qtip').qtip('hide');
                    $(`.objectdetail-map-tooltip-${plot.PlotNr}`).qtip('toggle');

                } else {
                    $(`#area-${plot.PlotNr}`).click();
                    this.clickFromOutsideMap = true;
                }

                if(window.innerWidth < 765 && plot.Coordinates !== "") {
                    $('html, body').animate({
                        scrollTop: $(this.mapImage).offset().top - $('.header').outerHeight(true)
                        // $(this.mapImage).offset().top + ($(this.mapImage).outerHeight(true) - $('.header').outerHeight(true))
                    }, 300);
                }
            }
        },
        togglePlotStatusPopup(plot, triggerHover = false, showPopUp = false) {
            if(this.body.classList.contains('non-touch-device')) {
                if (plot.Coordinates !== "" && !plot.Tooltip) {
                    $(`#area-${plot.PlotNr}`).qtip({
                        content: {
                            text: `<span data-area="${plot.PlotNr}">${plot.PlotNr} <br> ${plot.StatusFriendly}</span>`
                        },
                        style: {
                            classes: `objectdetail-map__status-qTip objectdetail-map-status-tooltip-${plot.PlotNr} objectdetail-map__status-qTip--${plot.Status}`,
                        },
                        position: {
                            container: $('.js-objectdetail-map'),
                            effect: function (api, pos, viewport) {
                                $(this).animate(pos, {
                                    duration: 0,
                                    easing: 'linear',
                                    queue: false,
                                    viewport: true,
                                });
                            },
                            my: 'bottom center',
                            at: 'top center',
                            adjust: {
                                screen: true,
                                x: 0,
                                y: 0
                            },
                        },
                        show: {
                            event: `mouseover`,
                            ready: true,
                        },
                        hide: {
                            event: `click mouseleave`
                        },
                        events: {
                            show: (e, api) => {
                                if($(`.objectdetail-map-tooltip-${plot.PlotNr}`).attr('aria-hidden') === "false") {
                                    api.tooltip.qtip('hide');
                                    return false;
                                }

                                const plotNr = api.target[0].id.split('-')[1];
                                this.togglePlotAccordion(e, plotNr);
                            },
                            hide: (e, api) => {
                                const plotNr = api.target[0].id.split('-')[1];
                                this.togglePlotAccordion(e, plotNr);
                            }
                        }
                    })
                    .removeData('qtip');

                    Vue.set(plot, 'Tooltip', true);
                    $(`#area-${plot.PlotNr}`).qtip('toggle', true);
                }

                //if hover is triggered outside map (accordion)
                if(triggerHover) {

                    if(showPopUp) {
                        $(`#area-${plot.PlotNr}`).mouseover();
                        this.hoverVisible = true;

                        if(plot.Tooltip) {
                            this.showMapHilight(plot.PlotNr);
                        }

                    } else {
                        this.removeMapHilights(plot);
                        this.hoverVisible = false;
                        $(`#area-${plot.PlotNr}`).mouseleave();
                    }
                }
            }
        },
        getListItem(plotNr, showAccordion, e) {
            //loop through all items in list
            for(let i = 0; i < this.plotList.length; i+=1) {
                //remove hover or focus status from all the items
                this.plotList[i].classList.remove('hover');
                this.plotList[i].classList.remove('focus');

                //find correspondening item
                if(this.plotList[i].getAttribute('data-id') === plotNr) {
                    const accordion = this.plotList[i].querySelector('.js-accordion-open');
                    const accordionCollapse = this.plotList[i].querySelector('.js-accordion-collapse');

                    //handle open accordion
                    if(showAccordion) {
                        //open accordion

                        if(!this.plotList[i].dataset.accordionActive && e.type !== 'tooltiphide') {
                            accordion.click();
                            this.plotList[i].classList.add('focus');
                        } else { //close accordion
                            this.plotList[i].removeAttribute('data-accordion-active');
                            accordionCollapse.style.height = '0px';
                            accordionCollapse.style.position = 'relative';
                            accordionCollapse.style.opacity = 1;
                            accordionCollapse.style.visibility = 'visible';
                            //close qtip
                        }
                    } else { //handle hover
                        if(!this.hoverVisible) {
                            //add hover state
                            this.plotList[i].classList.add('hover');
                            this.hoverVisible = true;
                        } else {
                            //remove hover state
                            this.plotList[i].classList.remove('hover');
                            this.hoverVisible = false;
                        }
                    }
                }
            }
        },
        getListItemByPlotNr(plotNr) {
            let item;
            this.plotList.forEach((listItem) => {
                if (listItem.dataset.id === plotNr) {
                    item = listItem;
                }
            });

            return item;
        },
        getPlotColor(plot) {
            switch (plot.Status)
            {
                case "IsSoonForSale":
                    return "4184dd";
                case "IsForSale":
                    return "4DFF9A";
                case "IsSold":
                    return "FF4D5E";
                case "IsInOption":
                    return "FFAC4D";
                default:
                    return "0be900";
            }
        },
        removeMapHilights(plot = null) {
            if (this.activeStatusFilters.length > 0) {
                // hovert plot
                if(plot !== null) {
                    let isActiveFilter = this.activeStatusFilters.includes(plot.Status);

                    if(!isActiveFilter) {
                        let plotArea = $(`#area-${plot.PlotNr}`).data('maphilight') || {};
                        plotArea.alwaysOn = false;
                        $(`#area-${plot.PlotNr}`).data('maphilight', plotArea).trigger('alwaysOn.maphilight');
                    }
                }

                for (let i = 0; i < this.activeStatusFilters.length; i += 1) {
                    mapAreas.forEach((area) => {
                        if (area.dataset.status !== this.activeStatusFilters[i]) {
                            let objectData = $(area).data('maphilight') || {};
                            objectData.alwaysOn = false;
                            $(area).data('maphilight', objectData).trigger('alwaysOn.maphilight');
                        } else {
                            return;
                        }
                    });
                }
            } else {
                this.mapAreas.forEach((area) => {
                    let objectData = $(area).data('maphilight') || {};
                    objectData.alwaysOn = false;
                    $(area).data('maphilight', objectData).trigger('alwaysOn.maphilight');
                });
            }
        },
        showMapHilight(plotNr) {
            let objectData = $(`#area-${plotNr}`).data('maphilight') || {};
            objectData.alwaysOn = true;
            $(`#area-${plotNr}`).data('maphilight', objectData).trigger('alwaysOn.maphilight');
        },
        hilightPlotsOnFilter(status) {
            let filterActive = false;
            for (let s = 0; s < this.statusFilters.length; s += 1) {
                if (this.statusFilters[s].dataset.status === status) {
                    if (this.statusFilters[s].classList.contains('is-active')) {
                        this.statusFilters[s].classList.remove('is-active');
                        filterActive = false;

                        let index = this.activeStatusFilters.indexOf(status);
                        this.activeStatusFilters.splice(index);

                    } else {
                        this.statusFilters[s].classList.add('is-active');
                        filterActive = true;

                        this.activeStatusFilters.push(status);
                    }
                }
            }

            for(let i = 0; i < this.objectPlots.length; i+=1) {
                if(this.objectPlots[i].Status === status) {
                    if (filterActive) {
                        this.showMapHilight(this.objectPlots[i].PlotNr);
                    } else {
                        let objectData = $(`#area-${this.objectPlots[i].PlotNr}`).data('maphilight') || {};
                        objectData.alwaysOn = false;
                        // objectData.neverOn = true;
                        $(`#area-${this.objectPlots[i].PlotNr}`).data('maphilight', objectData).trigger('alwaysOn.maphilight');
                    }
                }
            }
        }
    }
});